<template>
  <div id="app">
    <!-- 直接使用 router-view 让路由控制页面显示 -->
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>